import { oz } from '@weft/utils';

export const OneTimePricingConfigurationSchema = oz.object({
  price: oz.number({ invalid_type_error: 'Fixed amount is required' }),
}).openapi('OneTimePricingConfiguration');

export type OneTimePricingConfiguration = oz.infer<typeof OneTimePricingConfigurationSchema>;